import {Controller, useForm} from "react-hook-form";
import {ApiKeyFormCreateInputs} from "../../Models/ApiKeyForm";
import React from "react";
import {TextField} from "@mui/material";

type Props = {
    setPage: React.Dispatch<React.SetStateAction<string>>
    handleClose: () => void
    execSubmit: (name: string) => void
}

const CreateApiKeyForm: React.FC<Props> = ({setPage, handleClose, execSubmit}) => {

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm<ApiKeyFormCreateInputs>()


    const handleDialogClose = () => {
        reset()
        handleClose()
    }

    const handleFormSubmit = (e: any) => {
        e.preventDefault();
    }

    const onSubmit = (data: ApiKeyFormCreateInputs) => {
        const name = data.name != null ? data.name : ''
        execSubmit(name)
    }

    return (
        <div style={{margin: '20px'}}>

            <form onSubmit={handleFormSubmit}>
                <Controller
                    name='name'
                    control={control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({field}) => (
                        <TextField
                            {...field}
                            variant='outlined'
                            label='Name'
                            error={!!errors.name}
                            helperText={errors.name && 'Name required'}
                            fullWidth
                            required
                        />

                    )}
                />
                <div style={{display: 'flex', justifyContent: 'end', marginTop: '10px', gap: 10}}>
                    <button type="button" onClick={handleDialogClose} className="button button--secondary" >Cancel</button>
                    <button type="button" onClick={handleSubmit(onSubmit)} className="button button--primary" >Create</button>
                </div>
            </form>

        </div>
    )
}

export {CreateApiKeyForm}